import { MICRO_AUTH_URL } from "../helpers/Setting";

export default async ({ auth, body }) =>
  await fetch(MICRO_AUTH_URL, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: auth
    },
    method: "POST",
    body: body ? body : null
  })
    .then(res => res.json())
    .then(res => {
      if (res.errors) throw res.errors;
      return res.data;
    })
    .catch(err => {
      throw err;
    });
